import { signOut } from 'next-auth/react';
import { useCallback } from 'react';

import backendService from '../services/backendService';
import { clearPostAuthRedirect } from '../utils/postAuthRedirect';

async function attemptClearCache() {
  try {
    await backendService.instance.users.clearCache();
  } catch (error) {}
}

function useSignOut() {
  // There's no hosted IdP sign-out to round-trip through — clear the Curipod
  // session and land back on our own origin.
  const signOutAuto = useCallback(async (redirectUrl?: string) => {
    await attemptClearCache(); // Even if this fails, user should be signed out
    clearPostAuthRedirect();
    await signOut({ callbackUrl: redirectUrl || window.location.origin });
  }, []);

  return {
    signOutAuto,
  };
}

export default useSignOut;
